import { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, FormControl, InputLabel, Select, DialogActions, Button, MenuItem } from "@mui/material";
import adminAPI from '../../Services/Admin/adminAPI';

const TypeUpdateDialog = ({ open, handleClose, selectedIds }) => {
  const [typeIntervention, setTypeIntervention] = useState('');

  const handleChangeType = (event) => {
    setTypeIntervention(event.target.value);
  };

  const handleConfirm = async () => {
    try {
      // Vérifier que chaque élément de selectedIds est un entier
      if (selectedIds.some(id => typeof id !== 'number')) {
        console.error('IDs invalides');
        return;
      }

      // Envoi de la requête pour mettre à jour le type des nomenclatures spécifiées
      const response = await adminAPI.updateNomenclatureType({
        ids: selectedIds,
        type: typeIntervention
      });

      console.log('Succès:', response.data);
      handleClose(); // Fermer le dialogue après la confirmation
    } catch (error) {
      console.error('Erreur lors de la mise à jour du type:', error);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Modifier le type d'intervention</DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="normal">
          <InputLabel id="type-intervention-label">Type d'intervention</InputLabel>
          <Select
            labelId="type-intervention-label"
            id="type-intervention-select"
            value={typeIntervention}
            label="Type d'intervention"
            onChange={handleChangeType}
          >
            <MenuItem value={1}>Elective</MenuItem>
            <MenuItem value={2}>Traumatologie</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Annuler</Button>
        <Button onClick={handleConfirm} type="submit">Confirmer</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TypeUpdateDialog;
